import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { createElement, useState, useEffect, useRef } from 'react';
import SvelteSvg from './svelte';

var Svg = function Svg(_ref) {
  var id = _ref.id,
      illus = _ref.illus,
      className = _ref.className,
      w = _ref.w,
      h = _ref.h;

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      mounted = _useState2[0],
      setMounted = _useState2[1];

  var ref = useRef(null);
  useEffect(function () {
    var node = ref.current;
    if (!(node === null || node === void 0 ? void 0 : node.parentNode)) return;
    var fragment = document.createDocumentFragment();
    var svelte = new SvelteSvg({
      target: fragment,
      props: {
        id: id,
        illus: illus,
        class: className,
        w: w,
        h: h,
        $$scope: {
          ctx: {}
        }
      }
    });
    node.parentNode.insertBefore(fragment, node);
    setMounted(null);
    return function () {
      return svelte.$destroy();
    };
  }, []);
  return mounted && createElement('p', {
    ref: ref,
    className: 'hide'
  });
};

export default Svg;